import React from 'react';
import {ButtonBar, SaveButton, Field, Form, Split} from '../commons/Forms.js';
import {Pane, Part} from '../commons/Panes';
import {connect} from 'react-redux';
import {changeDates} from '../../redux/skiresorts/actions';
import '../../styles/adminPanels.less';

/** Panneau d'ajout d'une station */
@connect(
  () => ({}),
  {changeDates}
)
class OpeningDatesEdit extends React.Component {

  onSubmit(e) {
    e.preventDefault();

    let data = {
      openingDate: this.refs.openingDate.value(),
      closingDate: this.refs.closingDate.value(),
    };
    this.props.changeDates(data);
    this.props.onEnd();
    return false;
  }

  render() {
    let theForm = (
      <Form onSubmit={e => this.onSubmit(e)}>
        <p style={{ paddingTop: '5px' }}>Vous pouvez laisser un champ vide pour ne pas le mettre à jour</p>
        <Split>
          <Field ofType="date" label="Ouverture"
                 ref="openingDate"/>
          <Field ofType="date" label="Fermeture"
                 ref="closingDate"/>
        </Split>
        <ButtonBar>
          <SaveButton/>
        </ButtonBar>
      </Form>
    );

    return (
      <Pane title="Modifier les dates d'ouverture de toutes les stations">
        <Part title="Nouvelles dates">
          {theForm}
        </Part>
      </Pane>
    )
  }
}


export default OpeningDatesEdit;



// WEBPACK FOOTER //
// ./src/components/admin/OpeningClosingDateEdit.js